import clipboardCopy from 'clipboard-copy'

import { getApplicationBridge } from '@app/store/actions/contexts/applicationBridge'
import { getState } from '@app/store/actions/initial'
import type { StoreDispatch } from '@app/store/dispatch'
import { configSelector } from '@app/store/slices/config'
import { createThunk } from '@app/store/thunk'

export class ClipboardManager {
  dispatch: StoreDispatch

  constructor(dispatch: StoreDispatch) {
    this.dispatch = dispatch
  }

  copy(text: string) {
    void clipboardCopy(text)
    const isApp = configSelector(this.dispatch(getState())).appProtocol >= 2

    if (isApp) {
      const bridge = this.dispatch(getApplicationBridge())
      bridge?.sendMessage({
        type: 'copy_to_clipboard',
        text,
      })
    }
  }
}

const ClipboardManagerSymbol = Symbol('ClipboardManager')

export const getClipboardManager = () =>
  createThunk((dispatch, _getState, context) => {
    return context.getRootContext().getOrInsert(ClipboardManagerSymbol, () => new ClipboardManager(dispatch))
  })
